import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useRegionScope } from "../../../contexts/RegionScopeContext.js";
import { useSessionStorage } from "../../../hooks/useSessionStorage.js";
import { SelectReportTypeRenderComponents } from "./SelectReportType.js";
import { useEffect, useState } from "react";
import { Icon, MultiSelect, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useUpdateEffect } from "ahooks";
//#region src/modules/Reports/shared/SearchFilterReportTypeActiveInactiveMultiSelect.tsx
var LIMIT = 25;
function SearchFilterReportTypeActiveInactiveMultiSelect({ focused, onChange, onClearSelection, onClick, value }) {
	const [reportTypesTab, setReportTypesTab] = useState("active");
	const [activeReportTypes, setActiveReportTypes] = useSessionStorage("activeReportTypesFilter");
	const [inactiveReportTypes, setInactiveReportTypes] = useSessionStorage("inactiveReportTypesFilter");
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const { rpcService } = useRPCContext();
	const regionScope = useRegionScope();
	useEffect(() => {
		if (!value?.length) {
			setActiveReportTypes(void 0);
			setInactiveReportTypes(void 0);
		}
	}, [value]);
	useEffect(() => {
		setLoading(true);
		rpcService.Reports.GetReportTypesList.v1.call({
			active: reportTypesTab === "active",
			pagination: { limit: LIMIT },
			regionIds: regionScope
		}).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.reportTypes);
		}).finally(() => setLoading(false));
	}, [reportTypesTab, regionScope]);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Reports.GetReportTypesList.v1.call({
			active: reportTypesTab === "active",
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			regionIds: regionScope,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.reportTypes]);
		});
		else if (opts.text) rpcService.Reports.GetReportTypesList.v1.call({
			active: reportTypesTab === "active",
			pagination: { limit: LIMIT },
			regionIds: regionScope,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.reportTypes);
		});
	};
	useUpdateEffect(() => {
		onChange([...activeReportTypes || [], ...inactiveReportTypes || []]);
	}, [activeReportTypes, inactiveReportTypes]);
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface-strong p-xs",
		children: [/* @__PURE__ */ jsxs("div", {
			onClick: () => {
				if (focused) onClick("");
				else onClick("selectedReportTypeIds");
			},
			className: "flex w-full justify-between font-bold hover:cursor-pointer",
			children: [/* @__PURE__ */ jsx("span", { children: "Report Types" }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
		}), focused && /* @__PURE__ */ jsx("div", {
			className: "pt-xs",
			onClick: (e) => e.stopPropagation(),
			children: /* @__PURE__ */ jsxs(Tabs, {
				currentKey: reportTypesTab,
				onTabClick: setReportTypesTab,
				children: [/* @__PURE__ */ jsx(Tabs.Tab, {
					title: "Active",
					tabKey: "active",
					children: /* @__PURE__ */ jsx(MultiSelect, {
						disabled: loading,
						disableSelectAll: true,
						loading,
						loadOptions: handleLoadOptions,
						onChangeValue: (val) => {
							setActiveReportTypes(val);
						},
						onClearSelection,
						options,
						optionLabelExtractor: (option) => option.name,
						optionValueExtractor: (option) => option.id,
						placeholder: "Active Report Types",
						renderOption: (option) => /* @__PURE__ */ jsx(SelectReportTypeRenderComponents.ListItem, {
							name: option.name,
							color: option.color
						}),
						totalOptions,
						value: activeReportTypes || []
					})
				}), /* @__PURE__ */ jsx(Tabs.Tab, {
					title: "Inactive",
					tabKey: "inactive",
					children: /* @__PURE__ */ jsx(MultiSelect, {
						disabled: loading,
						disableSelectAll: true,
						loading,
						loadOptions: handleLoadOptions,
						onChangeValue: (val) => {
							setInactiveReportTypes(val);
						},
						onClearSelection,
						options,
						optionLabelExtractor: (option) => option.name,
						optionValueExtractor: (option) => option.id,
						placeholder: "Inactive Report Types",
						totalOptions,
						value: inactiveReportTypes || []
					})
				})]
			})
		})]
	});
}
//#endregion
export { SearchFilterReportTypeActiveInactiveMultiSelect };

//# sourceMappingURL=SearchFilterReportTypeActiveInactiveMultiSelect.js.map